import { modalData } from './mock/modalMock.js';

angular.module('Toke').factory('modalRepository', function ($q) {

    function getModal() {
        return $q.resolve(modalData)
    }

    // para lista futura
    // function getModalFromList() {

    //     const listUrl =
    //         baseUrl +
    //         "/_api/web/lists/getbytitle('Navbar')/items" +
    //         "?$select=Title,Url,ParentId,Order,IsActive" +
    //         "&$orderby=Order asc";

    //     return $http({
    //         method: 'GET',
    //         url: listUrl,
    //         headers: {
    //             Accept: 'application/json;odata=nometadata'
    //         }
    //     }).then(function (response) {
    //         return response.data.value;
    //     });
    // }



    return {
        getModal: getModal
    };

});

